export default {
  // task
  TASK__CREATE_TASK: 'TASK__CREATE_TASK',
  TASK__DELETE_TASK: 'TASK__DELETE_TASK',
  TASK__EDIT_TASK_NAME: 'TASK__EDIT_TASK_NAME',
  TASK__TOGGLE_TASK_STAR_STATUS: 'TASK__TOGGLE_TASK_STAR_STATUS',
  TASK__ADD_COMMENT_TO_TASK: 'TASK__ADD_COMMENT_TO_TASK',
  TASK__EDIT_COMMENT_TO_TASK: 'TASK__EDIT_COMMENT_TO_TASK',
  TASK__DELETE_COMMENT_TO_TASK: 'TASK__DELETE_COMMENT_TO_TASK',

  // piece
  PIECE__HIGHLIGHT_CONTENT: 'PIECE_HIGHLIGHT_CONTENT', // without saving
  PIECE__SNAPSHOT_CONTENT: 'PIECE__SNAPSHOT_CONTENT', // without saving
  PIECE__CREATE_HIGHLIGHT_PIECE: 'PIECE__CREATE_HIGHLIGHT_PIECE',
  PIECE__CREATE_SNAPSHOT_PIECE: 'PIECE__CREATE_SNAPSHOT_PIECE',
  PIECE__CREATE_MANUAL_PIECE: 'PIECE__CREATE_MANUAL_PIECE',
  PIECE__DELETE_PIECE: 'PIECE__DELETE_PIECE',
  PIECE__DELETE_PIECE_FOREVER: 'PIECE__DELETE_PIECE_FOREVER',
  PIECE__EMPTY_TRASH_CAN: 'PIECE__EMPTY_TRASH_CAN',
  PIECE__REVIVE_PIECE: 'PIECE__REVIVE_PIECE',
  PIECE__EDIT_PIECE_NAME: 'PIECE__EDIT_PIECE_NAME',
  PIECE__EDIT_PIECE_TEXT: 'PIECE__EDIT_PIECE_TEXT',
  PIECE__ADD_COMMENT_TO_PIECE: 'PIECE__ADD_COMMENT_TO_PIECE',
  PIECE__EDIT_COMMENT_TO_PIECE: 'PIECE__EDIT_COMMENT_TO_PIECE',
  PIECE__DELETE_COMMENT_TO_PIECE: 'PIECE__DELETE_COMMENT_TO_PIECE',

  // table
  TABLE__CREATE_NAMUAL_PIECE_AS_EVIDENCE:
    'PIECE__CREATE_NAMUAL_PIECE_AS_EVIDENCE',
  TABLE__CREATE_NAMUAL_PIECE_AS_OPTION: 'TABLE__CREATE_NAMUAL_PIECE_AS_OPTION',
  TABLE__CREATE_NAMUAL_PIECE_AS_CRITERION:
    'TABLE__CREATE_NAMUAL_PIECE_AS_CRITERION',
  TABLE_ADD_EVIDENCE_PIECE: 'TABLE_ADD_EVIDENCE_PIECE',
  TABLE_ADD_OPTION: 'TABLE_ADD_OPTION',
  TABLE_ADD_CRITERION: 'TABLE_ADD_CRITERION',
  TABLE_REMOVE_EVIDENCE_PIECE: 'TABLE_REMOVE_EVIDENCE_PIECE',
  TABLE_REMOVE_OPTION: 'TABLE_REMOVE_OPTION',
  TABLE_REMOVE_CRITERION: 'TABLE_REMOVE_CRITERION',
  TABLE_EVIDENCE_SWITCH_RATING_TYPE: 'TABLE_EVIDENCE_SWITCH_RATING_TYPE',

  // misc
  CONTEXT_SWITCH___MOUSE_ENTER_SIDEBAR: 'CONTEXT_SWITCH___MOUSE_ENTER_SIDEBAR',
  CONTEXT_SWITCH___MOUSE_LEAVE_SIDEBAR: 'CONTEXT_SWITCH___MOUSE_LEAVE_SIDEBAR',
  CONTEXT_SWITCH_FOCUS_ON_WEBAPP: 'CONTEXT_SWITCH_FOCUS_ON_WEBAPP',
  CONTEXT_SWITCH_BLUR_ON_WEBAPP: 'CONTEXT_SWITCH_BLUR_ON_WEBAPP'
};



// WEBPACK FOOTER //
// ../shared-components/src/firebase/wrappers/instrument_v1_event_types.js